module.exports = __webpack_public_path__ + "media/images/menu-history-active-icon-ab145871cf99140ce1f454f87ca77c05.svg";